import If from 'global/ErrorHandlers/If';

import { Key } from 'react';
import DetailModal from '.';
import { DataField, TableContainer } from './styled';

type DataSourceItem = JSX.Element | JSX.Element[] | string | number;

export interface DataSource {
  key?: Key;
  label: DataSourceItem;
  value: DataSourceItem;
}

interface iInfoTable {
  className?: string;
  dataSource: DataSource[];
  title?: string;
}

export const InfoTable = ({ dataSource, title = '', ...rest }: iInfoTable) => {
  if (!dataSource?.length) return null;
  return (
    <TableContainer {...rest} data-cy="trade-detail-modal-info-table-container">
      <If condition={title}>
        <legend data-cy="trade-detail-modal-info-table-title">{title}</legend>
      </If>
      {dataSource.map((d, i) => (
        <If condition={d.label} key={d?.key || `dt-${i}`}>
          <DataField data-cy="trade-detail-modal-info-table-item">
            {d.label} {d.value}
          </DataField>
        </If>
      ))}
    </TableContainer>
  );
};

export default DetailModal;
